export default __webpack_public_path__ + "static/media/Background_00213.be1440bf.png";